module.exports = __webpack_public_path__ + "images/icon-tweet.png?76309";